import delegate from '../../00-utilities/delegate';
import DropdownBase from "./DropdownBase";

export default class DropdownSelect extends DropdownBase{
  /**
   * Create a new Dropdown Component that works like a <select> Element
   * @param {HTMLElement} select - <select> Element
  */
  constructor() {
    super();
    delegate({
      target: '.dropdown--select:not(.dropdown--disabled) .dropdown__trigger',
      listener: this.onClickDropdownHeader.bind(this),
      event: 'click',
    });

    // Choose one option and close the Dropdown select
    delegate({
      target: '.dropdown--select:not(.dropdown--disabled) .dropdown__item--disabled',
      listener: this.onClickDropdownDisabledItemOption.bind(this),
      event: 'click',
    });

    // Choose one option and close the Dropdown select
    delegate({
      target: '.dropdown--select:not(.dropdown--disabled) .dropdown__item--option',
      listener: this.onClickDropdownItemOption.bind(this),
      event: 'click',
    });


    // Replace select with dropdown
    this.replaceAllSelect();

    this.setMinWidthToParent();

  }
  createNewSelectDropdown(select) {
    let dropdown = document.createElement('div');

    dropdown.classList.add('dropdown');
    select.classList.add('dropdown__select');
    // select.addEventListener('change',(e)=>{
      // console.log(e)
    // })

    select.classList.remove('dropdown');
    dropdown.classList.add('dropdown--select');

    // Check if dropdown is a full size select
    if(select.classList.contains('dropdown--block')) {
      dropdown.classList.add('dropdown--block');
      select.classList.remove('dropdown--block');
    }

    if(select.classList.contains('dropdown--no-scroll')) {
      dropdown.classList.add('dropdown--no-scroll');
      select.classList.remove('dropdown--no-scroll');
    }

    // Check if select disabled
    if(select.hasAttribute('disabled')) {
      dropdown.classList.add('dropdown--disabled');
    }

    let dropdownHeader = this.createNewSelectDropdownHeader(select);
    let dropdownContent = this.createNewSelectDropdownContent(select);

    // DOM operations

    // Replace select with dropdown
    select.parentElement.replaceChild(dropdown,select);

    // Add select to the dropdown
    dropdown.appendChild(select);
    // Add dropdownHeader to the dropdown
    dropdown.appendChild(dropdownHeader);
    // Add dropdownContent to the dropdown
    dropdown.appendChild(dropdownContent);
  }

  /**
   * Create a Dropdown Header for Select Type Dropdown
   * @param {HTMLElement} select - <Select> Element
   * @return {HTMLElement} Return a new Dropdown Header
  */
  createNewSelectDropdownHeader(select){
    // DROPDOWN HEADER
    let option;
    let dropdownHeader = document.createElement('div');
    dropdownHeader.classList.add('dropdown__trigger');
    // Check if select has a selected option
    if(select.querySelector('option:checked')) {
      option = select.querySelector('option:checked');
    }
    // Use text of the first Option
    else {
      option = select.querySelector('option');
    }
    // Check if selected option has a image on the left
    if(option.hasAttribute('data-image-left')) {
      dropdownHeader.innerHTML = `<svg class="icon icon--left" aria-hidden="true">
                                    <use xlink:href="${option.getAttribute("data-image-left")}"></use>
                                  </svg>
                                  <span class="dropdown__text-item">${option.text}</span>`;
    }

    // Check if selected option has a image on the right
    else if(option.hasAttribute('data-image-right')) {
      dropdownHeader.innerHTML = `<span class="dropdown__text-item">${option.text}</span>
                                  <svg class="icon icon--right" aria-hidden="true">
                                    <use xlink:href="${option.getAttribute("data-image-right")}"></use>
                                  </svg>
                                  `;
    }
    else {
      dropdownHeader.innerHTML = option.text;
    }
    return dropdownHeader;
  }

  /**
   * Create a Dropdown Content for Select Type Dropdown
   * @param {HTMLElement} select - <Select> Element
   * @return {HTMLElement} Return a new Dropdown Content
  */
  createNewSelectDropdownContent(select){
    // DROPDOWN Content
    let dropdownContent = document.createElement('ul');
    dropdownContent.classList.add('dropdown__content');

    let options = select.children;
    // Create list item
    for (let ii = 0; ii < options.length ; ii++) {
      let listItem = document.createElement('li');
      dropdownContent.appendChild(listItem);
      if(options[ii].hasAttribute('disabled')) {
        listItem.setAttribute('disabled','disabled');
        listItem.classList.add('dropdown__item--disabled');
      }
      listItem.classList.add('dropdown__item', 'dropdown__item--option');
      listItem.setAttribute('data-value',options[ii].getAttribute('value'));

      // Check if the options have a image on the left
      if(options[ii].hasAttribute('data-image-left')) {
        listItem.innerHTML = `<svg class="icon icon--left" aria-hidden="true">
                                <use xlink:href="${options[ii].getAttribute("data-image-left")}"></use>
                              </svg>
                              <span class="dropdown__text-item">${options[ii].text}</span>`;
      }
      // Check if the options have a image on the right
      else if(options[ii].hasAttribute('data-image-right')) {
        listItem.innerHTML = `<span class="dropdown__text-item">${options[ii].text}</span>
                              <svg class="icon icon--right" aria-hidden="true">
                                <use xlink:href="${options[ii].getAttribute("data-image-right")}"></use>
                              </svg>`;
      }
      else {
        listItem.innerHTML = `<span class="dropdown__text-item">${options[ii].text}</span>`;
      }
    }
    return dropdownContent;
  }

  /**
   * Create a Dropdown Content for Select Type Dropdown
   * @param {HTMLElement} select - <Select> Element
   * @return {HTMLElement} Return a new Dropdown Content
  */
  replaceAllSelect() {
    let selects = document.querySelectorAll('select.dropdown');

    for( let ii = 0 ; ii < selects.length ; ii++) {
      // Check if select's parent is a dropdown
      if(! selects[ii].parentElement.classList.contains('.dropdown')) {
        this.createNewSelectDropdown(selects[ii]);
      }
    }
  }

  /**
   * Select an option on .dropdown__item click
   * @param {Object} Event
  */
  onClickDropdownItemOption(e) {
    let select = e.target.parentElement.parentElement.querySelector('.dropdown__select');
    if (!e.target.hasAttribute('disabled')) {
      // True specs event
      // let event = new Event('change');
      // Polyfill
      // let event = new CustomEvent("lol");
      select.value = e.target.getAttribute('data-value');
      select.dispatchEvent(new Event('change'));
      // select.dispatchEvent(event);
      // Change Header text
      select.nextElementSibling.innerHTML = e.target.innerHTML;
    }
    else {
      return false;
    }
  }

  /**
   * Block disabled item click
   * @param {Object} Event
  */
  onClickDropdownDisabledItemOption(e) {
    e.stopImmediatePropagation();
    let select = e.target.parentElement.parentElement.querySelector('.dropdown__select');
  }
}
